import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment'

export default function AppDateLocalization({ children }) {
    return (
        <LocalizationProvider dateAdapter={AdapterMoment} adapterLocale='fr'>
            {children}
        </LocalizationProvider>
    )
}